import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet"
import isMobile from 'is-mobile';
import qs from 'query-string';
import PDPVideo from '../components/PDPVideo';
import track from 'we-sdk/utils/track';
import getLogger from 'we-sdk/utils/getLogger';
import LoadingCover from '../components/LoadingCover';
import { triggerInteractionsReport, removeEkoLogo, isTemplate } from '../lib/utils';

import '../styles/scss/components/trynbuy.scss'

const log = getLogger('trynbuy');

/**
 * try and buy static page that dynamically loads video with the id from querystring.
 * @export
 * @param {object} props
 * @returns
 */
export default function TryNBuy({ location, pageContext }) {
    const [ekoId, setEkoId] = useState(null);
    const [ekoPlayerRef, setEkoPlayerRef] = useState(null);
    const queryParams = qs.parse(location.search);

    useEffect(() => {
        if (!window.EkoAnalytics) {
            log.error("EkoAnalytics not found on window\nDid you forget to include the <EkoAnalytics /> component on the page?");
            return;
        }

        if (!isTemplate({ queryParams })) {
            return;
        }

        window.EkoAnalytics.registerContextPacker({
            schema: 'iglu:com.helloeko/template/jsonschema/1-0-1',
            match: /.*/g,
            getData: function () {
                return {
                    instanceid: queryParams.instanceid || '',
                    templateid: queryParams.projectId || ''
                };
            }
        });

        track('root.pageload', {
            projectId: queryParams.projectId,
            instanceId: queryParams.instanceid
        });
    }, [queryParams.projectId, queryParams.instanceid]);

    useEffect(() => {
        log.debug(`Loaded with eko ID ${queryParams.projectId}`);
        // IMPORTANT - THIS IS AN EXAMPLE TRACK CALL.
        // ACTUAL ANALYTICS SPEC/REQUIREMENTS WILL BE PROVIDED LATER
        track('root.pageload', {
            projectId: queryParams.projectId
        });

        if (queryParams.projectId) {

            setEkoId(queryParams.projectId)
        }
    }, [location]);

    useEffect(() => {
        if (!ekoPlayerRef) {
            return;
        }
        if (isMobile()) {
            setTimeout(() => {
                removeEkoLogo(ekoPlayerRef);
            }, 5000);
        }
    }, [ekoPlayerRef]);

    return (
        <>
            <Helmet>
                <title>{pageContext.productName}</title>
            </Helmet>
            <div className="eko-video-container">
                    {ekoId && <PDPVideo
                        id={ekoId}
                        embedAPI='2.0'
                        params={{ clearcheckpoints: true, cover: false }}
                        events={{

                            // Listen to the 'interactions' event in order to forward any interactions to parent frame as well
                            'interactions.report': (btnId, data) => {
                                // notify the parent frame that an interaction occurred
                                triggerInteractionsReport(btnId, data);
                            },
                        }}
                        onPlayerInit={setEkoPlayerRef}
                        loadingCover={LoadingCover}
                        location={location}
                    />}
            </div>

        </>
    );
};
